import { useState, type ReactElement } from 'react';
import { Suspense } from 'react';
import { RouterProvider, type createBrowserRouter } from 'react-router-dom';
import { useHtmlLangSync, useTranslation } from '@repo/locale';

// @shared/env must be imported before @router/index.
// router/index.tsx calls isApplicationMode() at module scope and
// depends on @shared/env having already initialized the environment.
import { getConfig } from '@shared/env';

import { createRouter } from '@router/index';

export function AppRouterProvider(): ReactElement {
  const [router] = useState<ReturnType<typeof createBrowserRouter>>(createRouter);
  const { i18n } = useTranslation();

  useHtmlLangSync({
    namespace: 'meta',
    titleKey: 'title',
    descriptionKey: 'description',
    keywordsKey: 'keywords',
    authorKey: 'author',
    robotsKey: 'robots',
    ogTitleKey: 'og.title',
    ogDescriptionKey: 'og.description',
    ogSiteNameKey: 'og.site_name',
    ogTypeKey: 'og.type',
    ogLocaleKey: 'og.locale',
    ogImageUrl: `${getConfig('appUrl')}/cover.png`,
  });

  return (
    <Suspense fallback={null}>
      <RouterProvider key={i18n.language} router={router} />
    </Suspense>
  );
}
